<template>
  <layout>
    <section class="title-bar">
      <div class="columns">
        <div class="column">
          <h1>Add Feedback Givers</h1>
          <hr />
        </div>
      </div>
    </section>

    <section class="block">
      <div class="columns">
        <div class="column">
          <div class="">
            <h3>
              In this section you can provide a list of people you would like to
              provide you with feedback, it's important to have a list with a
              varied selection of roles and relationships to you to give you the
              best information related to your performance.
            </h3>
            <hr />
          </div>
          <form @submit.prevent="submit">
            <b-message type="is-danger" v-if="errorsArray">
              <span v-for="(error, index) in errorsArray" :key="index">
                {{ error }}<br />
              </span>
            </b-message>
            <div :class="['box', { error: errorsArray.length > 0 }]">
              <div class="columns">
                <div class="column">
                  <b-field label="First Name">
                    <b-input v-model="feedbackForm.first_name"></b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Last Name">
                    <b-input v-model="feedbackForm.last_name"></b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="Email">
                    <b-input
                      type="email"
                      v-model="feedbackForm.email"
                    ></b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Relationship to you">
                    <b-select
                      expanded
                      placeholder="Select a name"
                      v-model="feedbackForm.relationship_id"
                    >
                      <option
                        v-for="relationship in relationships"
                        :value="relationship.id"
                        :key="relationship.id"
                      >
                        {{ relationship.name }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
              </div>
            </div>
            <div class="button-container">
              <b-button @click="submitFeedbackGiverForm()" type="is-primary"
                >Add</b-button
              >
            </div>
          </form>

          <p v-if="feedbackGivers.length > 0" class="mt-5 mb-2">
            <b>My Feedback Givers</b>
          </p>

          <div v-if="loadingFeedbackGivers.length > 0">
            <span
              class="addFBG"
              v-for="feedbackGiver in loadingFeedbackGivers"
              :key="feedbackGiver.email"
            >
              <NewFeedbackGiver
                :feedbackGiver="feedbackGiver"
                :relationships="relationships"
                :loading="true"
              />
            </span>
          </div>

          <span v-if="feedbackGivers.length > 0">
            <span
              class="addFBG"
              v-for="feedbackGiver in reversedFeedbackGivers"
              :key="feedbackGiver.email"
            >
              <NewFeedbackGiver
                :feedbackGiver="feedbackGiver"
                :relationships="relationships"
                :loading="false"
              />
            </span>
          </span>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import Layout from './Layout';
import NewFeedbackGiver from '../../Components/Feedback/NewFeedbackGiver';

class FeedbackGiver {
  constructor(args) {
    this.first_name = args.first_name ?? '';
    this.last_name = args.last_name ?? '';
    this.email = args.email ?? '';
    this.relationship_id = args.relationship_id ?? '';
    this.pivot = {
      relationship_id: args.relationship_id ?? '',
    };
  }
}

export default {
  components: {
    Layout,
    NewFeedbackGiver,
  },
  props: {
    project: Object,
    feedbackGivers: Array,
    relationships: Array,
  },
  data() {
    return {
      feedbackForm: {},
      loadingFeedbackGivers: [],
      error: [],
    };
  },
  methods: {
    addFeedbackGiver: function (feedbackGiver) {
      this.feedbackGivers.unshift(feedbackGiver);
    },

    addLoadingFeedbackGiver: function (feedbackGiver) {
      console.log('add loading feedbackgiver');
      console.dir(feedbackGiver);
      this.loadingFeedbackGivers.unshift(feedbackGiver);
    },

    removeLoadingFeedbackGiver: function (feedbackGiver) {
      this.loadingFeedbackGivers = this.loadingFeedbackGivers.filter((elem) => {
        return feedbackGiver.email !== elem.email;
      });
    },

    submitFeedbackGiverForm: function () {
      // clear errors
      this.error = [];
      this.$page.props.errors = {};

      // validate data
      if (this.isDuplicateEmail() || this.isOwnEmail() || this.isFieldEmpty()) {
        return false;
      }

      // create new instance of feedback giver
      var feedbackGiver = new FeedbackGiver(this.feedbackForm);

      // add feedback giver to loading array
      this.addLoadingFeedbackGiver(feedbackGiver);

      // clear the feedback giver form
      this.feedbackForm = new FeedbackGiver({
        relationship_id: this.relationships[0].id,
      });

      // send ajax put data to server
      this.saveFeedbackGiver(feedbackGiver);
    },

    // sends request to server to save feedback giver
    saveFeedbackGiver: function (feedbackGiver) {
      this.$inertia.put(
        route(
          'feedback.project.updateProvideFeedbackGivers',
          this.project.unique_id
        ),
        {
          feedback_givers: [feedbackGiver],
        },
        {
          preserveScroll: true,
          onSuccess: (page) => {
            this.loadingFeedbackGivers.splice(0, 1);
            if (Object.keys(page.props.errors).length > 0) {
              this.handleError(feedbackGiver);
            }
          },
          onError: () => {
            this.handleError(feedbackGiver);
          },
        }
      );
    },

    // handles errors of feedback form
    handleError: function (feedbackGiver) {
      this.feedbackForm = feedbackGiver;
      this.error.push('Something went wrong, please try again.');
    },

    // check whether an email already exists in the feedback giver list
    isDuplicateEmail: function () {
      for (var i = 0; i < this.feedbackGivers.length; i++) {
        if (this.feedbackGivers[i].email == this.feedbackForm.email) {
          this.error.push('The email address already exists in this list.');
          return true;
        }
      }
      return false;
    },

    // this function checks whether an email already exists
    isOwnEmail: function () {
      if (this.feedbackForm.email !== this.$page.props.auth.user.email) {
        return false;
      }
      this.error.push('You cannot add your own email.');
      return true;
    },

    // make sure all the fields of the feedback form have been filled in
    isFieldEmpty: function () {
      var feedbackFormArr = Object.values(this.feedbackForm);
      for (var i = 0; i < feedbackFormArr.length; i++) {
        if (feedbackFormArr[i] == null || feedbackFormArr[i] == '') {
          this.error.push('Please fill in all the fields below.');
          return true;
        }
      }
      return false;
    },
  },
  computed: {
    // reverses feedback giver array so that most recently added are first
    reversedFeedbackGivers: function () {
      return this.feedbackGivers.reverse();
    },

    // array that combines the errors returned by inertia with errors returned through front-end validation
    errorsArray: function () {
      if (!this.$page.props.errors) return false;
      return this.error.concat(Object.values(this.$page.props.errors));
    },
  },
  mounted() {
    // this clears the feedback form, apart from the relationship dropdown, which displays the first relationship by default
    this.feedbackForm = new FeedbackGiver({
      relationship_id: this.relationships[0].id,
    });
  },
};
</script>
